import axios from "axios";
import { API_URL } from "constants.js";
import { PostData } from "./build-pdf-utils";

export function submitDocument(companyId: string, data: PostData) {
  const url = `${API_URL}/${companyId}/files/build-pdf`;
  return axios.post(url, data).then((response) => response.data);
}

export function updateDocument(companyId: string, data: PostData, fileId: string) {
  const url = `${API_URL}/${companyId}/files/build-pdf/${fileId}`;
  return axios.patch(url, data).then((response) => response.data);
}

export function fetchSystemTemplateFields(companyId: string, slotKey: string) {
  const url = `${API_URL}/${companyId}/system-template-fields/${slotKey}`;
  return axios.get(url).then((response) => response.data);
}
